import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';

import { DatePickerNew, Select } from 'common-src/components/base';
import { ExemptionSource } from 'common-src/models/PatientBillingExemption';
import {
  PayorType,
  PayorTypeOptions,
  validatePatientCoverage,
} from 'common-src/models/PatientCoverage';

import { InfoItem } from 'src/components/elements';

import { MfaPlanOption } from '../../constants';

const typeOptions = [...PayorTypeOptions, MfaPlanOption];

const Mfa = ({ data, handleInputChange, handleDateChange, errors, setErrors }) => (
  <>
    <Select
      id="insurance-type"
      label="Please select insurance type"
      options={typeOptions}
      onChange={(op) => handleInputChange('payorType', op.value)}
      value={
        typeOptions.find((op) => op.value === data.payorType) ||
        Object.values(PayorType).find((op) => op.value === data.payorType)
      }
      required
      placeholder="-"
    />
    <span />
    <span />
    <InfoItem title="Waiver" content="100%" textId="waiver-rate" />
    <InfoItem
      title="Source"
      content={
        Object.values(ExemptionSource).find((op) => op.value === data.source)?.label || 'User Input'
      }
      textId="source"
    />
    <span />
    <DatePickerNew
      id="start-date"
      header="Start date"
      placeholder="Select date"
      value={data.startDate}
      onDateSelected={(date) =>
        handleDateChange(
          'startDate',
          'endDate',
          true,
          date ? moment(date).format('YYYY-MM-DD') : null,
        )
      }
      onBlur={(date) =>
        setErrors((prev) => ({ ...prev, ...validatePatientCoverage('startDate', date, data) }))
      }
      errorText={errors.startDate}
      required
    />
    <DatePickerNew
      id="end-date"
      header="End date"
      placeholder="Select date"
      value={data.endDate}
      onDateSelected={(date) =>
        handleDateChange(
          'endDate',
          'startDate',
          false,
          date ? moment(date).format('YYYY-MM-DD') : null,
        )
      }
      onBlur={(date) =>
        setErrors((prev) => ({ ...prev, ...validatePatientCoverage('endDate', date, data) }))
      }
      errorText={errors.endDate}
      required
    />
  </>
);

Mfa.propTypes = {
  data: PropTypes.object,
  errors: PropTypes.object,
  setErrors: PropTypes.func,
  handleDateChange: PropTypes.func,
  handleInputChange: PropTypes.func,
};

export default Mfa;
